/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DashboardObiettiviPlDto interface.
 */
export function instanceOfDashboardObiettiviPlDto(value) {
    return true;
}
export function DashboardObiettiviPlDtoFromJSON(json) {
    return DashboardObiettiviPlDtoFromJSONTyped(json, false);
}
export function DashboardObiettiviPlDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'budgetRevenueLow': json['budgetRevenueLow'] == null ? undefined : json['budgetRevenueLow'],
        'budgetMargineProgettoLow': json['budgetMargineProgettoLow'] == null ? undefined : json['budgetMargineProgettoLow'],
        'budgetMargineProgettoTarget': json['budgetMargineProgettoTarget'] == null ? undefined : json['budgetMargineProgettoTarget'],
        'budgetMargineCommercialeGruppo': json['budgetMargineCommercialeGruppo'] == null ? undefined : json['budgetMargineCommercialeGruppo'],
        'budgetMargineProgettoPerc': json['budgetMargineProgettoPerc'] == null ? undefined : json['budgetMargineProgettoPerc'],
        'revenueLow': json['revenueLow'] == null ? undefined : json['revenueLow'],
        'margineProgettoLow': json['margineProgettoLow'] == null ? undefined : json['margineProgettoLow'],
        'margineProgettoPerc': json['margineProgettoPerc'] == null ? undefined : json['margineProgettoPerc'],
        'margineCommercialeGruppo': json['margineCommercialeGruppo'] == null ? undefined : json['margineCommercialeGruppo'],
    };
}
export function DashboardObiettiviPlDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'budgetRevenueLow': value['budgetRevenueLow'],
        'budgetMargineProgettoLow': value['budgetMargineProgettoLow'],
        'budgetMargineProgettoTarget': value['budgetMargineProgettoTarget'],
        'budgetMargineCommercialeGruppo': value['budgetMargineCommercialeGruppo'],
        'budgetMargineProgettoPerc': value['budgetMargineProgettoPerc'],
        'revenueLow': value['revenueLow'],
        'margineProgettoLow': value['margineProgettoLow'],
        'margineProgettoPerc': value['margineProgettoPerc'],
        'margineCommercialeGruppo': value['margineCommercialeGruppo'],
    };
}
